// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XoyFdE{position:fixed;top:0;bottom:0;right:0;left:0;z-index:6001;cursor:move}.gs3gyF{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fixer": `XoyFdE`,
	"hidden": `gs3gyF`
};
export default ___CSS_LOADER_EXPORT___;
